module.exports = __webpack_public_path__ + "img/Scanvaegt4.80476e84.png";